import "rc-tooltip/assets/bootstrap.css";
import Slider from "rc-slider";
import type { SliderProps } from "rc-slider";
import raf from "rc-util/lib/raf";
import Tooltip from "rc-tooltip";
import { useEffect, useRef } from "react";

const HandleTooltip = (props: {
    value: number;
    children: React.ReactElement;
    visible: boolean;
    tipFormatter?: (value: number) => React.ReactNode;
}): JSX.Element => {
    const { value, children, visible, ...restProps } = props;

    const tooltipRef = useRef<any>();
    const rafRef = useRef<number | null>(null);

    const cancelKeepAlign = (): void => {
        raf.cancel(rafRef.current!);
    };

    const keepAlign = (): void => {
        rafRef.current = raf(() => {
            tooltipRef.current?.forcePopupAlign();
        });
    };

    useEffect(() => {
        if (visible) {
            keepAlign();
        } else {
            cancelKeepAlign();
        }

        return cancelKeepAlign;
    }, [value, visible]);

    return (
        <Tooltip
            placement="top"
            overlay={value}
            overlayInnerStyle={{ minHeight: "auto" }}
            ref={tooltipRef}
            visible={visible}
            {...restProps}
        >
            {children}
        </Tooltip>
    );
};

export const handleRender: SliderProps["handleRender"] = (node, props) => {
    return (
        <HandleTooltip value={props.value} visible={props.dragging}>
            {node}
        </HandleTooltip>
    );
};

const TooltipSlider = ({
    tipFormatter,
    tipProps,
    ...props
}: SliderProps & { tipFormatter?: (value: number) => React.ReactNode; tipProps: any }): JSX.Element => {
    const tipHandleRender: SliderProps["handleRender"] = (node, handleProps) => {
        return (
            <HandleTooltip
                value={handleProps.value}
                visible={handleProps.dragging}
                tipFormatter={tipFormatter}
                {...tipProps}
            >
                {node}
            </HandleTooltip>
        );
    };

    return <Slider {...props} handleRender={tipHandleRender} />;
};

export default TooltipSlider;
